import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import { getPatientByMSBN } from "~/store/patient/patientAction";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const FindBHYTPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/FindBHYTByScanQrCode"
    ),
  loading: LoadableLoading
});
const FindBHYTPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/mobile/pages/FindBHYTByScanQrCode"
    ),
  loading: LoadableLoading
});

class FindBHYT extends Component {
  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <FindBHYTPageMobile {...this.props} />
        ) : (
          <FindBHYTPageDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    patient: { showLoading }
  } = state;
  return {
    device: type,
    showLoading
  };
};

const FindBHYTHelmet = withTitle({
  component: FindBHYT,
  title: `${hospitalName.value} | Tìm mã số BHYT`
});

export default connect(mapStateToProps, {
  getPatientByMSBN
})(FindBHYTHelmet);
